import { render, staticRenderFns } from "./MultipleColumns.vue?vue&type=template&id=56fcf72d&scoped=true"
import script from "./MultipleColumns.vue?vue&type=script&lang=js"
export * from "./MultipleColumns.vue?vue&type=script&lang=js"
import style0 from "./MultipleColumns.vue?vue&type=style&index=0&id=56fcf72d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fcf72d",
  null
  
)

export default component.exports